import { render, staticRenderFns } from "./ShouninRouteStep.vue?vue&type=template&id=2d6d8994&scoped=true&"
import script from "./ShouninRouteStep.vue?vue&type=script&lang=ts&"
export * from "./ShouninRouteStep.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninRouteStep.vue?vue&type=style&index=0&id=2d6d8994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6d8994",
  null
  
)

export default component.exports